import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';


export default function TermsOfServicePage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
          Termos de Uso e Serviço
        </h1>
        <p className="text-sm text-gray-500">
          Última atualização: 29 de maio de 2026
        </p>
      </div>

      {/* Conteúdo */}
      <div className="space-y-6 text-gray-700">
        {/* Aceitação */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            1. Aceitação dos Termos
          </h2>
          <p className="leading-relaxed">
            Ao acessar e utilizar a plataforma VUKZ (“Plataforma”, “Serviço”, “nós” ou “nosso”), de propriedade da VUKZ AI (Arena Stats CNPJ 61.698.906/0001-16),
            você (“Usuário”, “Contratante”, “você”) concorda em cumprir e estar vinculado a estes Termos de Uso. 
            Se você não concordar com qualquer parte destes termos, não utilize nossos serviços.
          </p>
        </section>

        {/* Descrição do Serviço */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            2. Descrição do Serviço
          </h2>
          <p className="mb-3">
            A VUKZ é uma plataforma SaaS de Performance OS para esportes, que oferece:
          </p>
          <ul className="space-y-1 ml-4">
            <li>• Gestão de treinos, sessões, agenda e planejação esportiva</li>
            <li>• Agentes de IA especializados (treinador, atleta, preparador físico, gestor)</li>
            <li>• Resultados, rankings e estatísticas de natação e futebol</li>
            <li>• Análise de vídeo e biomecânica (SwimVision, TrackVision)</li>
            <li>• Ferramentas de análise e gestão para clubes e federações</li>
            <li>• Inteligência editorial e conteúdo esportivo com IA</li>
          </ul>
          <p className="mt-3 text-sm" style={{ color: BRAND_GOLD }}>
            <strong>Nota:</strong> O serviço é fornecido conforme o plano contratado e sujeito ao Acordo de Nível de Serviço (SLA) disponível em <a href="/sla" style={{ color: BRAND_GREEN, fontWeight: 600 }}>vukz.ai/sla</a>.
          </p>
        </section>

        {/* Cadastro e Conta */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            3. Cadastro e Conta de Usuário
          </h2>
          
          <h3 className="text-lg font-semibold mb-2" style={{ color: BRAND_GOLD }}>
            3.1 Elegibilidade
          </h3>
          <p className="mb-4">
            Para criar uma conta, você deve ter pelo menos 13 anos de idade. 
            Menores de 18 anos devem ter consentimento dos pais ou responsáveis legais.
          </p>

          <h3 className="text-lg font-semibold mb-2" style={{ color: BRAND_GOLD }}>
            3.2 Informações de Cadastro
          </h3>
          <p className="mb-3">
            Ao criar uma conta, você concorda em:
          </p>
          <ul className="space-y-1 mb-4 ml-4">
            <li>• Fornecer informações verdadeiras, precisas e atualizadas</li>
            <li>• Manter a confidencialidade da sua senha</li>
            <li>• Notificar imediatamente sobre uso não autorizado da conta</li>
            <li>• Não compartilhar credenciais com terceiros</li>
          </ul>

          <h3 className="text-lg font-semibold mb-2" style={{ color: BRAND_GOLD }}>
            3.3 Dados de Preferências Esportivas
          </h3>
          <div className="bg-green-50 rounded-lg p-4 border" style={{ borderColor: BRAND_GREEN }}>
            <p className="mb-2">
              Durante o cadastro, solicitamos informações sobre suas preferências esportivas 
              (esportes de interesse, esportes praticados, times favoritos, etc.).
            </p>
            <p className="font-semibold mb-2" style={{ color: BRAND_GREEN }}>
              Uso destes dados:
            </p>
            <ul className="space-y-1 text-sm">
              <li>✓ Personalização da experiência na plataforma</li>
              <li>✓ Recomendações de conteúdo relevante</li>
              <li>✓ Estudos estatísticos com dados <strong>anonimizados</strong></li>
              <li>✓ Pesquisa acadêmica (sempre respeitando a LGPD)</li>
            </ul>
            <p className="mt-3 text-sm font-semibold" style={{ color: BRAND_GREEN }}>
              Você pode revisar e modificar suas preferências a qualquer momento no perfil.
            </p>
          </div>
        </section>

        {/* Uso Aceitável */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            4. Uso Aceitável
          </h2>
          
          <h3 className="text-lg font-semibold mb-2" style={{ color: BRAND_GOLD }}>
            4.1 Você PODE:
          </h3>
          <ul className="space-y-1 mb-4 ml-4">
            <li>✓ Acessar e visualizar estatísticas esportivas</li>
            <li>✓ Criar e gerenciar sua conta pessoal</li>
            <li>✓ Compartilhar conteúdo público da plataforma (com atribuição)</li>
            <li>✓ Utilizar dados para uso pessoal e não comercial</li>
          </ul>

          <h3 className="text-lg font-semibold mb-2" style={{ color: BRAND_GOLD }}>
            4.2 Você NÃO PODE:
          </h3>
          <ul className="space-y-1 ml-4">
            <li>✗ Copiar, reproduzir ou redistribuir dados em larga escala</li>
            <li>✗ Utilizar bots, scrapers ou ferramentas automatizadas</li>
            <li>✗ Acessar dados de outros usuários sem autorização</li>
            <li>✗ Realizar engenharia reversa da plataforma</li>
            <li>✗ Utilizar dados para finalidades comerciais sem autorização</li>
            <li>✗ Publicar conteúdo ofensivo, difamatório ou ilegal</li>
            <li>✗ Tentar burlar medidas de segurança</li>
            <li>✗ Sobrecarregar os servidores (DoS/DDoS)</li>
          </ul>
        </section>

        {/* Propriedade Intelectual */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            5. Propriedade Intelectual
          </h2>
          <p className="mb-3">
            Todo conteúdo da plataforma (textos, gráficos, logos, ícones, imagens, código, design, modelos de IA)
            é propriedade da VUKZ AI ou de seus licenciadores e protegido por leis de direitos autorais.
          </p>
          <p className="mb-3">
            <strong>Dados esportivos:</strong> Agregamos dados de fontes pública e APIs de terceiros. 
            Respeitamos os direitos dos provedores originais.
          </p>
          <p>
            <strong>Uso permitido:</strong> Você pode visualizar e usar dados para fins da organização contratante dentro da plataforma. 
            Para redistribuição comercial ou integrações de terceiros, entre em contato conosco.
          </p>
        </section>

        {/* Privacidade e LGPD */}
        <section className="bg-green-50 rounded-xl border-2 p-6" style={{ borderColor: BRAND_GREEN }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            6. Privacidade e Proteção de Dados (LGPD)
          </h2>
          <p className="mb-3">
            O tratamento dos seus dados pessoais é regido pela nossa{' '}
            <a href="/privacidade" className="font-semibold hover:underline" style={{ color: BRAND_GREEN }}>
              Política de Privacidade
            </a>
            , em conformidade com a LGPD (Lei 13.709/2018).
          </p>
          
          <div className="bg-white rounded-lg p-4 border" style={{ borderColor: BRAND_GREEN }}>
            <p className="font-semibold mb-2" style={{ color: BRAND_GREEN }}>
              Resumo dos seus direitos:
            </p>
            <ul className="space-y-1 text-sm">
              <li>• Acessar seus dados pessoais</li>
              <li>• Corrigir informações incorretas</li>
              <li>• Solicitar exclusão de dados</li>
              <li>• Revogar consentimento para uso em pesquisas</li>
              <li>• Portabilidade de dados</li>
              <li>• Opor-se ao tratamento de dados</li>
            </ul>
          </div>

          <p className="mt-3 text-sm">
            <strong>Consentimento para Pesquisa:</strong> Ao marcar a opção de consentimento no cadastro, 
            você autoriza o uso de dados de preferências esportivas (anonimizados) para estudos estatísticos 
            e pesquisa acadêmica. Este consentimento pode ser revogado a qualquer momento.
          </p>
        </section>

        {/* Isenção de Responsabilidade */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            7. Isenção de Responsabilidade
          </h2>
          <p className="mb-3 font-semibold" style={{ color: BRAND_GOLD }}>
            O SERVIÇO É FORNECIDO "COMO ESTÁ" E "CONFORME DISPONÍVEL".
          </p>
          <p className="mb-3">
            Não garantimos:
          </p>
          <ul className="space-y-1 ml-4">
            <li>• Precisão absoluta de estatísticas e dados</li>
            <li>• Disponibilidade ininterrupta da plataforma</li>
            <li>• Ausência de erros ou bugs</li>
            <li>• Atualização em tempo real de todos os dados</li>
          </ul>
          <p className="mt-3">
            <strong>Apostas:</strong> Esta plataforma NÃO incentiva ou facilita apostas esportivas. 
            Não nos responsabilizamos por decisões de apostas baseadas em nossas informações.
          </p>
        </section>

        {/* Limitação de Responsabilidade */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            8. Limitação de Responsabilidade
          </h2>
          <p>
            Em nenhuma circunstância seremos responsáveis por danos diretos, indiretos, incidentais, 
            especiais ou consequentes resultantes de:
          </p>
          <ul className="space-y-1 mt-2 ml-4">
            <li>• Uso ou impossibilidade de usar a plataforma</li>
            <li>• Erros ou imprecisões em dados esportivos</li>
            <li>• Perda de dados ou informações</li>
            <li>• Interrupções de serviço</li>
            <li>• Acesso não autorizado à sua conta</li>
          </ul>
        </section>

        {/* Modificações */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            9. Modificações do Serviço e Termos
          </h2>
          <p className="mb-3">
            Reservamo-nos o direito de:
          </p>
          <ul className="space-y-1 mb-3 ml-4">
            <li>• Modificar, suspender ou descontinuar a plataforma a qualquer momento</li>
            <li>• Alterar estes Termos de Uso mediante notificação</li>
            <li>• Limitar acesso a certos recursos ou regiões</li>
          </ul>
          <p>
            Alterações significativas serão notificadas com pelo menos 7 dias de antecedência. 
            O uso continuado após alterações constitui aceitação dos novos termos.
          </p>
        </section>

        {/* Suspensão e Encerramento */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            10. Suspensão e Encerramento de Conta
          </h2>
          <p className="mb-3">
            Podemos suspender ou encerrar sua conta imediatamente se:
          </p>
          <ul className="space-y-1 mb-3 ml-4">
            <li>• Violar estes Termos de Uso</li>
            <li>• Utilizar a plataforma de forma abusiva ou ilegal</li>
            <li>• Fornecer informações falsas</li>
            <li>• Representar risco à segurança ou outros usuários</li>
          </ul>
          <p>
            Você pode encerrar sua conta a qualquer momento através das configurações de perfil 
            ou entrando em contato conosco.
          </p>
        </section>

        {/* Lei Aplicável */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            11. Lei Aplicável e Foro
          </h2>
          <p>
            Estes Termos são regidos pelas leis da República Federativa do Brasil. 
            Fica eleito o foro da comarca de Belo Horizonte/MG, com exclusão de qualquer outro, 
            por mais privilegiado que seja, para dirimir quaisquer questões oriundas destes Termos.
          </p>
        </section>

        {/* Contato */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            12. Contato
          </h2>
          <p className="mb-3">
            Para dúvidas sobre estes Termos de Uso:
          </p>
          <div className="bg-gray-50 rounded-lg p-4">
            <p><strong>E-mail:</strong> contato@vukz.ai</p>
            <p className="mt-2">
              <Link 
                to="/contato"
                className="font-semibold hover:underline"
                style={{ color: BRAND_GREEN }}
              >
                Acesse nossa página de contato →
              </Link>
            </p>
          </div>
        </section>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t-2" style={{ borderColor: 'var(--brand-border)' }}>
          <p className="text-center text-sm text-gray-600">
            Ao utilizar a VUKZ, você concorda com estes Termos de Uso.
            <br />
            Leia também nossa{' '}
            <Link to="/privacidade" className="font-semibold hover:underline" style={{ color: BRAND_GREEN }}>
              Política de Privacidade
            </Link>
            {' '}e nosso{' '}
            <Link to="/sla" className="font-semibold hover:underline" style={{ color: BRAND_GREEN }}>
              Acordo de Nível de Serviço
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
